import * as tslib_1 from "tslib";
import styled from '../styles';
var QuickJumperWrapper = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin: 0px 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin: 0px 16px;\n"])));
export default QuickJumperWrapper;
var templateObject_1;
//# sourceMappingURL=QuickJumperWrapper.js.map